// Single source of truth for option DISPLAY order. The option values and their
// base order come live from the GitHub field — we layer only two derived rules
// on top, so the sidebar groups, the /q facet bar and the issue sheet's pickers
// can never drift from each other (or from GitHub):
//
//   • client   → alphabetical (a long flat list; GitHub's insertion order is
//                unscannable). Derived, so new clients still appear automatically.
//   • workload → alphabetical (86+ manifestIds; same unscannable-flat-list reason).
//   • quarter  → chronological (GitHub leaves a rolled-over quarter stranded).
//
// Every other dimension uses the live field order verbatim — add or reorder an
// option in GitHub and it flows straight through.
import { parseQuarterName } from './quarter'

const alpha = (a: string, b: string) => a.localeCompare(b)

const byQuarter = (a: string, b: string) => {
  const qa = parseQuarterName(a)
  const qb = parseQuarterName(b)
  if (!qa || !qb) return 0
  return qa.start.getTime() - qb.start.getTime()
}

// Keyed lower-case so both facet keys ('client') and field names ('Client') hit it.
const COMPARATORS: Record<string, (a: string, b: string) => number> = {
  client: alpha,
  workload: alpha,
  quarter: byQuarter,
}

/** Name-comparator for a dimension, or null when GitHub's live order stands. */
export function optionComparator(dimension: string): ((a: string, b: string) => number) | null {
  return COMPARATORS[dimension.toLowerCase()] ?? null
}

/** Order a dimension's option names for display (no-op when live order stands). */
export function orderOptions(dimension: string, names: string[]): string[] {
  const cmp = optionComparator(dimension)
  return cmp ? [...names].sort(cmp) : names
}
